import {css} from "styled-components";
import {IButtonStyles} from "modules/types/theme";

export const linkStyles = (styles: IButtonStyles) => {
	const {
		color,
		background,
		borderColor,
		disabledColor,
		disabledBackground,
		disabledBorderColor,
		hoverColor,
		hoverBackground,
		hoverBorderColor,
		fontWeight,
	} = styles;

	return css`
		display: inline-flex;
		align-items: center;
		justify-content: center;
		color: ${color};
		background-color: ${background};
		border-color: ${borderColor};
		font-weight: ${fontWeight};
		font-size: 16px;

		&:hover {
			color: ${hoverColor};
			background-color: ${hoverBackground};
			border-color: ${hoverBorderColor};
		}

		&.disabled {
			color: ${disabledColor};
			background-color: ${disabledBackground};
			border-color: ${disabledBorderColor};
			cursor: initial;
			pointer-events: none;
		}
	`;
};
